import React from 'react';
import { Upload } from './features/upload/Upload';
import { SvgResult } from './features/svgResult/SvgResult';
import { FormData } from './features/formData/FormData';
import './App.css';
import Box from '@mui/material/Box';
import Paper from '@mui/material/Paper';
import { styled } from '@mui/material/styles';
import { ThemeProvider, createTheme } from '@mui/material/styles';
import * as config from './config.js';

function App() {
  const theme = createTheme({
    components: {
      // Name of the component
      MuiButton: {
        styleOverrides: {

          contained: {
            // Some CSS
            color:"#fff",
            backgroundColor: config.DABEEO_COLOR,
            fontSize: '1rem',
          },
        },
      },
      MuiRadio: {
        styleOverrides: {
          root: {
            color: 'green',
          },
          colorSecondary: {
            '&$checked': {
              color: 'green',
            },
          },
        },
      },
    },
  });

  const InlineLayout = styled(Paper)(() => ({
    float:"left",
    width:"50%",
    height:"100%",
    boxSizing: "border-box",
    padding:"10px",
    '& .left_section': {
      height:"50%"
    },
  }));
  return (
    <div className="App">
      <ThemeProvider theme={theme}>
        <Box sx={{
            width: "100%",
            height: "100%",
            backgroundColor: 'primary.dark',
          }}>
            <InlineLayout >
              <Upload />
              <SvgResult></SvgResult>
            </InlineLayout>
            <InlineLayout>
              <FormData />
            </InlineLayout>
        </Box>
      </ThemeProvider>
    </div>
  );
}


export default App;
